<template>
  <div class="create-tracking-category-amount-popup">
    <colored-popup :class="variant" :back-action="back">

      <template v-slot:top-content>
        <div class="title">
          הוספת קטגוריה למעקב
        </div>
      </template>

      <template v-slot:bottom-content>
        <div class="title">כמה כסף צפוי לצאת על ״<span class="bold">{{ selectedTrackingCategory.label }}</span>״ בחודש {{ currentMonthName }}?</div>
        <shekel-input :value="amount" :on-input="setAmount" :autofocus="true"/>

        <div class="affect-on-variables">
          <div class="question">איך זה משפיע על המשתנות?</div>
          <div class="expense-progress-container">
            <expense-progress :recommended-or-expected-amount="variableExpenses.recommendedOrExpectedAmount - (amount || 0)"
                              recommended-or-expected-label="מומלץ להוציא עד"
                              up-to-now-label="יצא עד עכשיו"
                              :up-to-now-amount="variableExpenses.upToNowAmount"
                              :show-warning-if-exceeding-budget="true"/>

          </div>
        </div>

        <riseup-button :action="save"
                       :variant="'primary'"
                       :title="'יצירת קטגוריה חדשה'"
                       :disabled="!amount"/>
      </template>

    </colored-popup>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import BaseUI from 'base-ui';
import moment from 'moment';
import Segment from '../../../../../../../../../../Segment';
import cashflowViewConsts from '../../../../../../../../../../constants/cashflow-view';
import ExpenseProgress from '../../../../generic-components/cashflow-types/cashflow-types-base/ExpenseProgress.vue';
import dateUtils from '../../../../../../../../../../utils/dates';
import ShekelInput from './ShekelInput.vue';

export default {
  name: 'CreateTrackingCategoryAmountPopup',
  components: {
    ColoredPopup: BaseUI.ColoredPopup,
    RiseupButton: BaseUI.RiseupButton,
    ExpenseProgress,
    ShekelInput,
  },
  created() {
    Segment.trackUserInteraction('CreateTrackingCategoryAmount_Entered', {
      selectedTrackingCategory: this.selectedTrackingCategory,
    });
  },
  computed: {
    ...mapState('cashflowView', ['cashflowUITree']),
    ...mapState('createTrackingCategory', ['selectedTrackingCategory', 'amount']),
    variant() {
      return cashflowViewConsts.CATEGORY_STYLE[cashflowViewConsts.CASHFLOW_CATEGORIES.TRACKING];
    },
    currentMonthName() {
      return dateUtils.getHebrewMonth(moment().toDate());
    },
    variableExpenses() {
      return this.cashflowUITree[cashflowViewConsts.cashflowTypes.variableExpense];
    },
  },
  methods: {
    ...mapActions('createTrackingCategory', ['setAmount', 'showTrackingCategory']),
    back() {
      Segment.trackUserInteraction('CreateTrackingCategoryAmount_BackClicked', {
        selectedTrackingCategory: this.selectedTrackingCategory,
      });
      this.$emit('back-clicked');
    },
    async save() {
      Segment.trackUserInteraction('CreateTrackingCategoryAmount_SaveClicked', {
        selectedTrackingCategory: this.selectedTrackingCategory,
        amount: this.amount,
      });
      await this.showTrackingCategory();
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss">
  @import '~base-ui/src/scss/riseup-colors';

  .create-tracking-category-amount-popup {
    text-align: right;

    .colored-top {
      color: $riseup_white;

      .title {
        font-size: 24px;
        font-weight: bold;
      }
    }

    .bottom {
      .cashflow-type-color {
        color: $riseup_mustard;
      }

      .cashflow-type-background-color {
        background-color: $riseup_mustard;
      }

      .title {
        margin-bottom: 13px;
        font-size: 18px;
        .bold {
          font-weight: bold;
        }
      }

      .affect-on-variables {
        margin: 50px 0 60px;
        border-radius: 10px;
        border: solid 1px $riseup_v2_grey;
        box-shadow: 0 2px 5px 0 $riseup_v2_grey;
        .question {
          padding: 14px;
          border-bottom: solid 1px $riseup_v2_grey;
          font-weight: bold;
          font-size: 16px;
        }
        .expense-progress-container {
          height: 93px;
          padding: 20px 20px 0px;
        }
      }

      .riseup-button {
        width: 100%;
      }
    }
  }

</style>
